// import React, { useEffect, useState } from "react";
// import "./Dashboards.css";
// import "./rbd.css";
// import ebillsJsonData from "./EbillCode_working.json";
// import BillPlans from "./BillPlans";

// const ElectricityBillPay = () => {
//   const [showBillPlans, setShowBillPlans] = useState(false);
//   const [billers, setBillers] = useState([]);
//   const [errors, setErrors] = useState({});
//   const [boardSearch, setBoardSearch] = useState("");
//   const [showBoardDropdown, setShowBoardDropdown] = useState(false);

//   const [formData, setFormData] = useState({
//     billerName: "",
//     billercode: "",
//     fields: {},
//   });

//   useEffect(() => {

//     const extractFieldsFromApiParams = (apiParams) => {
//       if (!apiParams) {
//         return [{
//           id: "rnum",
//           name: "Consumer Number",
//           maxLen: 20,
//           regex: "^[0-9a-zA-Z]+$",
//           required: true,
//         }];
//       }

//       const fields = [];

//       /* ================= rnum ================= */
//       const rnumMatch = apiParams.match(/pass\s(.*?)\sin\s'rnum'/i);
//       fields.push({
//         id: "rnum",
//         name: rnumMatch ? rnumMatch[1].trim() : "Consumer Number",
//         maxLen: 30,
//         regex: "^[0-9a-zA-Z]+$",
//         required: true,
//       });

//       /* ================= optional ================= */
//       const optionalMatch = apiParams.match(
//         /(?:,|\band\b)\s*(.*?)\s+in\s+'?optional'?/i
//       );

//       if (optionalMatch) {
//         fields.push({
//           id: "optional",
//           name: optionalMatch[1].trim(),
//           maxLen: 40,
//           regex: "^[0-9a-zA-Z@._/-]+$",
//           required: false,
//         });
//       }

//       /* ================= optional1 ================= */
//       const optional1Match = apiParams.match(
//         /\band\s+(.*?)\s+in\s+'?optional1'?/i
//       );

//       if (optional1Match) {
//         const formatMatch = apiParams.match(
//           /optional1.*?(\d{2}\/\d{2}\/\d{4})/i
//         );

//         fields.push({
//           id: "optional1",
//           name: formatMatch
//             ? `${optional1Match[1].trim()} (${formatMatch[1]})`
//             : optional1Match[1].trim(),
//           maxLen: 20,
//           regex: "^[0-9/]+$",
//           required: false,
//         });
//       }

//       return fields;
//     };


//     const electricityBillers = ebillsJsonData
//       .filter((item) => item.ebill_type === "Ebill")
//       .map((b) => ({
//         name: b.ebill_board,
//         code: b.ebill_code,
//         fields: extractFieldsFromApiParams(b[" API PARAMETERS"]),
//       }));

//     setBillers(electricityBillers);
//   }, []);

//   const selectedBiller = billers.find(
//     (b) => b.code === formData.billerName
//   );

//   const filteredBoards = billers.filter((b) =>
//     b.name.toLowerCase().includes(boardSearch.toLowerCase())
//   );

//   /* ================= HANDLERS ================= */
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;

//     if (name === "billerName") {
//       const biller = billers.find((b) => b.code === value);
//       setFormData({
//         billerName: value,
//         billercode: biller?.code || "",
//         fields: {},
//       });
//     }
//   };

//   const handleFieldChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       fields: { ...prev.fields, [name]: value },
//     }));
//   };

//   const handleClear = () => {
//     setFormData({ billerName: "", billercode: "", fields: {} });
//     setBoardSearch("");
//     setShowBoardDropdown(false);
//     setErrors({});
//   };


//   const handleProceed = () => {
//     setShowBillPlans(true);
//   };

//   return (
//     <div className="w-full px-4 py-6">

//       <div className="max-w-5xl mx-auto bg-white rounded-3xl shadow-lg p-6">

//         <div className="mb-6 border-b pb-4">
//           <h2 className="text-2xl font-bold text-[#12345A]">
//             Electricity Bill Payment
//           </h2>
//           <p className="text-gray-500 text-sm mt-1">
//             Secure & fast payment
//           </p>
//         </div>

//         {!showBillPlans && (
//           <div className="bg-white border rounded-2xl p-6">

//             <div className="relative mt-2">
//               <input
//                 type="text"
//                 placeholder="Search electricity board"
//                 value={boardSearch}
//                 onChange={(e) => {
//                   setBoardSearch(e.target.value);
//                   setShowBoardDropdown(true);
//                 }}
//                 onFocus={() => setShowBoardDropdown(true)}
//                 className="w-full px-4 py-3 rounded-xl border focus:ring-2 focus:ring-[#12345A] outline-none"
//               />

//               {showBoardDropdown && (
//                 <div className="absolute z-20 mt-2 w-full max-h-52 overflow-y-auto bg-white border rounded-xl shadow-md">
//                   {filteredBoards.length > 0 ? (
//                     filteredBoards.map((b) => (
//                       <div
//                         key={b.code}
//                         onClick={() => {
//                           setFormData({
//                             billerName: b.code,
//                             billercode: b.code,
//                             fields: {},
//                           });
//                           setBoardSearch(b.name);
//                           setShowBoardDropdown(false);
//                         }}
//                         className="px-4 py-3 text-sm cursor-pointer hover:bg-gray-50"
//                       >
//                         {b.name}
//                       </div>
//                     ))
//                   ) : (
//                     <div className="px-4 py-3 text-sm text-gray-400">
//                       No board found
//                     </div>
//                   )}
//                 </div>
//               )}
//             </div>

//             {/* DYNAMIC FIELDS */}
//             {selectedBiller?.fields.map((field) => (
//               <div key={field.id} className="mb-5">
//                 <label className="text-sm text-gray-600">
//                   {field.name}
//                 </label>

//                 <input
//                   type="text"
//                   name={field.id}
//                   value={formData.fields[field.id] || ""}
//                   onChange={handleFieldChange}
//                   placeholder={`Enter ${field.name}`}
//                   className="w-full mt-2 px-4 py-3 rounded-xl border focus:ring-2 focus:ring-[#12345A] outline-none"
//                 />
//               </div>
//             ))}

//             {/* BUTTONS */}
//             <div className="flex gap-3 mt-6">
//               <button
//                 onClick={handleClear}
//                 className="px-6 py-3 rounded-xl border text-gray-600 hover:bg-gray-50"
//               >
//                 Clear
//               </button>

//               <button
//                 onClick={handleProceed}
//                 className="px-8 py-3 rounded-xl bg-[#12345A] text-white font-semibold"
//               >
//                 Proceed
//               </button>
//             </div>
//           </div>
//         )}

//         {showBillPlans && (
//           <BillPlans
//             operator={formData.billercode}
//             billerCategory="ebill"
//             rnum={formData.fields}
//             onBack={() => setShowBillPlans(false)}
//           />
//         )}
//       </div>
//     </div>
//   );
// };

// export default ElectricityBillPay;


import React, { useEffect, useState, useRef } from "react";
import "./Dashboards.css";
import "./rbd.css";
import ebillsJsonData from "./EbillCode_working.json";
import BillPlans from "./BillPlans";

const ElectricityBillPay = () => {
  const [showBillPlans, setShowBillPlans] = useState(false);
  const [billers, setBillers] = useState([]);
  const [errors, setErrors] = useState({});
  const [boardSearch, setBoardSearch] = useState("");
  const [showBoardDropdown, setShowBoardDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const [formData, setFormData] = useState({
    billerName: "",
    billercode: "",
    fields: {},
  });

  // Handle click outside to close dropdown safely
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowBoardDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const extractFieldsFromApiParams = (apiParams) => {
      if (!apiParams) {
        return [
          {
            id: "rnum",
            name: "Consumer Number",
            maxLen: 20,
            regex: "^[0-9a-zA-Z]+$",
            required: true,
          },
        ];
      }

      const fields = [];

      /* ================= rnum ================= */
      const rnumMatch = apiParams.match(/pass\s(.*?)\sin\s'rnum'/i);
      fields.push({
        id: "rnum",
        name: rnumMatch ? rnumMatch[1].trim() : "Consumer Number",
        maxLen: 30,
        regex: "^[0-9a-zA-Z]+$",
        required: true,
      });

      /* ================= optional ================= */
      const optionalMatch = apiParams.match(
        /(?:,|\band\b)\s*(.*?)\s+in\s+'?optional'?/i
      );

      if (optionalMatch) {
        fields.push({
          id: "optional",
          name: optionalMatch[1].trim(),
          maxLen: 40,
          regex: "^[0-9a-zA-Z@._/-]+$",
          required: false,
        });
      }

      /* ================= optional1 ================= */
      const optional1Match = apiParams.match(
        /\band\s+(.*?)\s+in\s+'?optional1'?/i
      );

      if (optional1Match) {
        const formatMatch = apiParams.match(
          /optional1.*?(\d{2}\/\d{2}\/\d{4})/i
        );

        fields.push({
          id: "optional1",
          name: formatMatch
            ? `${optional1Match[1].trim()} (${formatMatch[1]})`
            : optional1Match[1].trim(),
          maxLen: 20,
          regex: "^[0-9/]+$",
          required: false,
        });
      }

      return fields;
    };

    const electricityBillers = ebillsJsonData
      .filter((item) => item.ebill_type === "Ebill")
      .map((b) => ({
        name: b.ebill_board,
        code: b.ebill_code,
        fields: extractFieldsFromApiParams(b[" API PARAMETERS"]),
      }));

    setBillers(electricityBillers);
  }, []);

  const selectedBiller = billers.find((b) => b.code === formData.billerName);

  const filteredBoards = billers.filter((b) =>
    b.name.toLowerCase().includes(boardSearch.toLowerCase())
  );

  /* ================= HANDLERS ================= */
  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      fields: { ...prev.fields, [name]: value },
    }));
  };

  const handleClear = () => {
    setFormData({ billerName: "", billercode: "", fields: {} });
    setBoardSearch("");
    setShowBoardDropdown(false);
    setErrors({});
  };

  const handleProceed = () => {
    setShowBillPlans(true);
  };

  return (
    <div className="min-h-screen w-full bg-white flex flex-col items-center justify-start pt-12 md:pt-0 px-6 font-sans">
      <div className="w-full pt-12">
      {/* <div className="w-full max-w-2xl pt-12"> */}
        
        {/* HEADER */}
        <h2 className="text-3xl md:text-4xl font-bold text-[#12345A] text-center mb-10 tracking-tight">
          Electricity Bill Payment
        </h2>

        {!showBillPlans ? (
          <div className="w-full">
            
            {/* ==========================================
                BOARD SEARCH DROPDOWN (Matches DTH Style)
               ========================================== */}
            <div className="mb-6 relative" ref={dropdownRef}>
              <label className="text-gray-600 font-semibold text-sm block mb-2 uppercase tracking-wide">
                Select Electricity Board
              </label>
              
              <div className="relative">
                <input
                  type="text"
                  placeholder="Search by state or board name..."
                  value={boardSearch}
                  onChange={(e) => {
                    setBoardSearch(e.target.value);
                    setShowBoardDropdown(true);
                  }}
                  onFocus={() => setShowBoardDropdown(true)}
                  className={`w-full rounded-none bg-transparent border-b-2 text-gray-900 px-3 py-4 text-xl md:text-2xl focus:outline-none transition-all ${
                    showBoardDropdown ? "border-[#12345A]" : "border-gray-200 focus:border-[#12345A]"
                  }`}
                />
                {/* Search Icon */}
                <svg className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 text-gray-400 pointer-events-none" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>

              {/* Dropdown Menu List */}
              {showBoardDropdown && (
                <div className="absolute z-20 w-full mt-2 bg-white border border-gray-100 rounded-2xl shadow-[0_10px_40px_rgb(0,0,0,0.08)] overflow-hidden max-h-72 overflow-y-auto animate-[fadeIn_.2s_ease-out]">
                  {filteredBoards.length > 0 ? (
                    filteredBoards.map((b) => (
                      <div
                        key={b.code}
                        onClick={() => {
                          setFormData({
                            billerName: b.code,
                            billercode: b.code,
                            fields: {},
                          });
                          setBoardSearch(b.name);
                          setShowBoardDropdown(false);
                        }}
                        className={`px-5 py-4 text-xl cursor-pointer transition-colors ${
                          selectedBiller?.code === b.code 
                            ? "bg-indigo-50 border-l-4 border-[#12345A]" 
                            : "hover:bg-gray-50 border-l-4 border-transparent"
                        }`}
                      >
                        <span className="text-gray-900 font-medium">{b.name}</span>
                      </div>
                    ))
                  ) : (
                    <div className="px-5 py-6 text-lg text-gray-400 font-medium text-center">
                      No electricity board found.
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* ==========================================
                DYNAMIC FIELDS (Only visible if board is selected)
               ========================================== */}
            {selectedBiller && (
              <div className="animate-[fadeIn_.3s_ease]">
                
                {selectedBiller.fields.map((field) => (
                  <div key={field.id} className="mb-6">
                    <label className="text-gray-600 font-semibold text-sm block mb-2 uppercase tracking-wide">
                      {field.name}
                    </label>
                    <input
                      type="text"
                      name={field.id}
                      value={formData.fields[field.id] || ""}
                      onChange={handleFieldChange}
                      placeholder={`Enter ${field.name.toLowerCase()}`}
                      className="w-full rounded-none bg-transparent border-b-2 border-gray-200 text-gray-900 px-3 py-4 text-xl md:text-2xl focus:outline-none focus:border-[#12345A] transition-all"
                    />
                  </div>
                ))}

                {/* Submit Buttons */}
                <div className="flex flex-col sm:flex-row gap-4 mt-10 mb-10">
                  <button
                    onClick={handleClear}
                    className="w-full sm:w-1/3 bg-transparent border-2 border-gray-200 text-gray-500 font-bold text-lg py-4 rounded-xl hover:bg-gray-50 hover:border-gray-300 transition-all focus:outline-none"
                  >
                    Clear Form
                  </button>

                  <button
                    onClick={handleProceed}
                    disabled={!formData.fields.rnum}
                    className="w-full sm:w-2/3 bg-[#12345A] text-white font-bold text-lg py-4 rounded-xl shadow-lg hover:bg-[#0d2644] hover:shadow-xl focus:ring-4 focus:ring-[#12345A]/20 transition-all disabled:opacity-60 disabled:cursor-not-allowed flex justify-center items-center"
                  >
                    Fetch Bill Details
                  </button>
                </div>

              </div>
            )}
          </div>
        ) : (
          /* ==========================================
             BILL PLANS COMPONENT
            ========================================== */
          <div className="w-full animate-[fadeIn_.3s_ease-out]">
            <BillPlans
              operator={formData.billercode}
              billerCategory="ebill"
              rnum={formData.fields}
              onBack={() => setShowBillPlans(false)}
            />
          </div>
        )}

      </div>
    </div>
  );
};

export default ElectricityBillPay;